<template>
  <div :class="$style['LAB_SAMPLES_RECEIVED']">
    <pt-form-item label="是否通过：" labelWidth="120px" :required="true">
      <el-radio-group v-model="form.result" name="result" v-validate="'required'" data-vv-as="是否通过">
        <el-radio label="APPROVED">通过</el-radio>
        <el-radio label="REJECT">驳回</el-radio>
      </el-radio-group>
    </pt-form-item>
    <pt-form-item label="选择原因：" labelWidth="120px" v-if="form.result !== 'APPROVED'" :required="true">
      <wt-selector :options="options" name="reason" data-vv-as="原因" v-validate="'required'" v-model="form.reason" :clearable="true" :allow-create="true" :filterable="true" @mousedown.stop.native @click.stop.native :props="reasonProps" :noDataText="'暂无选项，请您直接录入内容'"></wt-selector>
		</pt-form-item>
  </div>
</template>

<script>
import {
  validate
} from 'utils/validate'
import {
  nextTrust
} from '../status.js'

export default {
  props: {
    order: {
      type: Object
    },
    status: {
      type: String,
      required: true
    },
    isLot: {
      type: Boolean,
      default: false
    },
    billIds: [Array]
  },
  data () {
    return {
      options: [],
      title: '待审核',
      form: {
        result: 'APPROVED',
        reason: '',
      },
      reasonProps: {
        label: 'name',
        value: 'id'
      },
    }
  },
  watch:{
    form:{
      handler:function(val){
        this.$emit('input', val)
      },
      deep:true
    }
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    
    next () {
      let data = {
        action: this.status,
        billStatusDetail:{
          action: this.status,
          billStatusResult:this.form.result,
          reason: this.form.result === 'REJECT' ? this.form.reason : null,
        }
      }
      if(this.isLot){
        this.$delete(data,'billId')
        data.billIds = this.billIds
      }else{
        data.billId =  this.order.id
      }
      return nextTrust.call(this, data,this.isLot)
    },
  },
  created () {
  }
}

</script>

<style module lang="less">
// .LAB_SAMPLES_RECEIVED{
//   :global{
//     .el-input,
//     .el-input__inner {
//       width: 280px !important;
//     }
//   }
// }
// .specification-table-div {
//   margin-bottom: 20px;
//   padding: 10px 20px 30px;
// }

// .specification-table {
//   display: table !important;
//   width: 100%;
//   border-collapse: collapse !important;

//   th,
//   tr {
//     width: 100% !important;
//     max-width: 100% !important;
//     display: table-row !important;
//     padding: 0 !important;
//     list-style-type: none;
//     justify-content: center !important;
//     border-bottom: 1px solid #c6c9d3;
//     color: #5b5b5b !important;
//   }

//   td {
//     color: #5b5b5b !important;
//     text-align: center;
//     justify-content: flex-start !important;
//     padding: 10px;
//   }
// }
</style>
